import { render, staticRenderFns } from "./Error403.vue?vue&type=template&id=2847f1f4&scoped=true&"
import script from "./Error403.vue?vue&type=script&lang=ts&"
export * from "./Error403.vue?vue&type=script&lang=ts&"
import style0 from "./Error403.vue?vue&type=style&index=0&id=2847f1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2847f1f4",
  null
  
)

export default component.exports